import Layout from '@/layout';

export default {
  path: '/remoteControl',
  redirect: '/remoteControl/index',
  component: Layout,
  meta: {
    title: '远程控制',
    icon: 'iconfont icon-remote-control-fill',
    code: '0102041'
  },
  children: [
    {
      path: 'index',
      name: 'remoteControl',
      component: () => import('@/views/remoteControl/index'),
      props: true,
      meta: {
        title: '远程控制',
        icon: 'iconfont icon-remote-control-fill',
        code: '01020411'
      }
    }
  ]
};
